import axios from "axios"

export default {
    // Get tutorials for current user's organization
    getTutorials(params = {}) {
        const defaultParams = { page: 1, limit: 200, ...params }
        return axios.get('../tutorials', { params: defaultParams })
        .then(({data}) => data)
        .catch(({response}) => Promise.reject(response))
    },

    // Get all tutorials for admin management
    getAllTutorials(params = {}) {
        return axios.get('../tutorials/admin/all', { params })
        .then(({data}) => data)
        .catch(({response}) => Promise.reject(response))
    },

    // Create a new tutorial (admin)
    createTutorial(tutorialData) {
        return axios.post('../tutorials', tutorialData)
        .then(({data}) => data)
        .catch(({response}) => Promise.reject(response))
    },

    // Update a tutorial (admin)
    updateTutorial(id, tutorialData) {
        return axios.put(`../tutorials/${id}`, tutorialData)
        .then(({data}) => data)
        .catch(({response}) => Promise.reject(response))
    },

    // Delete a tutorial (admin)
    deleteTutorial(id) {
        return axios.delete(`../tutorials/${id}`)
        .then(({data}) => data)
        .catch(({response}) => Promise.reject(response))
    },

    // Read global tutorial exclusion status for an organization (admin)
    getGlobalExclusionStatus(organization_id) {
        return axios.get('../tutorials/admin/global-exclusion/status', { params: { organization_id } })
        .then(({data}) => data)
        .catch(({response}) => Promise.reject(response))
    },

    // Update global tutorial exclusion flag for an organization (admin)
    setGlobalExclusion(organization_id, excludeGlobalTutorials) {
        return axios.put('../tutorials/admin/global-exclusion', { organization_id, excludeGlobalTutorials })
        .then(({data}) => data)
        .catch(({response}) => Promise.reject(response))
    }
}

